import { FILTERS } from "../components/FilterSection/data/filtersList";
import { FilterState, filtersMap } from "./formatFilterState";
import getFilterActiveStatus from "./getFilterActiveStatus";
import { asList, isStandardToken, makeToken, updateApplicationOrder } from "./filterTokens";

/** Ordered per option (each selected option is its own token); relaxed per group (P1D-5538). */
const PER_OPTION_KEYS = new Set<string>(["amenities", "bills_included"]);

/** Every token currently applied, in search-panel order (the `FILTERS` order). */
export const tokensFromFilters = (filters: FilterState = {}): string[] =>
  FILTERS.flatMap(({ name, key }) => {
    if (PER_OPTION_KEYS.has(key)) {
      const stateKey = filtersMap[key as keyof typeof filtersMap] as keyof FilterState;
      return asList(filters?.[stateKey]).map((v) => makeToken(key, v));
    }
    return getFilterActiveStatus(name, filters) ? [key] : [];
  });

export const hasStandardFilter = (filters: FilterState = {}) =>
  tokensFromFilters(filters).some(isStandardToken);

/**
 * Next application order after `filters` replace `prevFilters`. The order lives in Redux only,
 * so after a reload it starts empty: seed it from the filters already on the page (panel order)
 * so a newly added filter still lands last.
 */
export const nextApplicationOrder = (
  prev: string[] = [],
  filters: FilterState = {},
  prevFilters: FilterState = {},
) =>
  updateApplicationOrder(
    prev.length ? prev : tokensFromFilters(prevFilters),
    tokensFromFilters(filters),
  );
